import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`
          fixed top-0 left-0 z-40 h-full w-64 transition-transform duration-300
          bg-blue-900 text-white shadow-lg
          ${sidebarOpen || !isMobile ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <Sidebar />
      </div>

      {/* Toggle Button */}
      {isMobile && (
        <button
          className="fixed top-4 left-4 z-50 bg-blue-600 text-white px-4 py-2 rounded shadow"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? "Close Menu" : "Open Menu"}
        </button>
      )}

      {/* Main layout with header, content, footer */}
      <div className={`${isMobile ? "w-full" : "ml-64"} pt-16`}>
        <Header />
        <main className="p-4">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
